import { Palette, SxProps, Theme } from "@mui/material";
import { borderGeneralStyle } from "@utils/cssStyles";

export const chatMessageRowSx = (isUser: boolean): SxProps<Theme> => ({
  justifyContent: isUser ? "flex-end" : "flex-start",
  mb: 2,
});

export const chatMessageColumnSx = (isUser: boolean): SxProps<Theme> => ({
  width: isUser ? undefined : "100%",
  maxWidth: isUser ? "85%" : "100%",
  display: "flex",
  flexDirection: "column",
  gap: 1,
});

export const userMessageHoverWrapperSx = {
  "&:hover .user-message-copy": {
    opacity: 1,
  },
};

export const userMessagePaperSx = (palette: Palette) => ({
  p: 2,
  backgroundColor: palette.text.input,
  color: palette.text.secondary,
  ...borderGeneralStyle,
  borderRadius: 2,
  ml: "auto",
});

export const userMessageCopyRowSx = {
  justifyContent: "flex-end",
  opacity: 0,
  transition: "opacity 0.15s",
};

export const showMoreButtonSx = {
  textTransform: "none",
  px: 0,
  minWidth: 0,
  mt: 0.5,
  fontSize: 10,
};

export const aiPlainTextPaperSx = (palette: Palette) => ({
  p: 2,
  backgroundColor:
    palette.mode === "dark" ? palette.grey[800] : palette.grey[100],
  color: palette.text.primary,
  borderRadius: 2,
});
